import React, { useState } from 'react';
import { CustomForm, CustomInput, RequestInfoAlert } from '../../../fgs';
import { Col, Container, FormGroup } from "reactstrap";
import { signinForm } from "../../forms";
import { signinValidations, signinValidationMessages } from '../../validations';
import { setAuthToken } from "../../../fgs/context/RequestContext";
import logo from "../../../assets/images/fgs-logo.png";

import { doSignin } from '../../../services/api';



export const SignInPage = () => {
  const [form, setForm] = useState(signinForm);
  const [invalidLogin, setInvalidLogin] = useState(false);

  const onChange = (e) => {
    const newForm = Object.assign({}, form);
    newForm[e.target.name] = e.target.value;

    setForm(newForm);
  };

  const onLogin = () => {
    doSignin(form)
      .then(response => {
        if (response) {
          setAuthToken(response.data.auth_token);
          location.href = "/home";
        }
      })
      .catch(error => {
        if (error?.response?.status === 401) {
          setInvalidLogin(true);
        }
      });
  };

  const renderAlert = () => {
    if (invalidLogin) {
      return (
        <RequestInfoAlert
          color={'warning'}
          message={'Login ID ou Senha Inválidos!'}
          expires={4000} />
      );
    }

  };

  const formControls = [
    { title: 'Entrar', props: { color: 'primary', type: 'submit' } },
  ];

  return (
    <Container fluid className="login-page-wrapper">
      <div className="login-box">
        <div className="login-header">
          <Col xs="12">
            <img src={logo} alt="Company logo" />
            { renderAlert() }
          </Col>
        </div>
        <div className="login-form">
          <Col xs="12">
            <CustomForm
              validationMessages={signinValidationMessages}
              validations={signinValidations}
              form={form}
              formControls={formControls}
              onSubmit={onLogin}>

              <FormGroup>
                <CustomInput
                  labelText="Login ID"
                  hasIcon={true}
                  iconName="User"
                  iconPosition="prepend"
                  inputName="accessId"
                  onChange={onChange}
                  inputValue={form.accessId} />

                <CustomInput
                  labelText="Senha"
                  hasIcon={true}
                  iconName="Lock"
                  iconPosition="prepend"
                  inputName="password"
                  inputType="password"
                  placeholder="****"
                  onChange={onChange}
                  inputValue={form.password}
                  actionIcon="Eye" />
              </FormGroup>
            </CustomForm>
          </Col>
        </div>
      </div>
    </Container>
  );
};